import { HandlerType, StatusHandlersTypes, apiConfigs } from "@payping/api";
import { setShowTOTPModal } from "@payping/redux/actions";
import { Message } from "@payping/web-components";
import * as Sentry from "@sentry/react";

import { userManager } from "@/utils/userManager";
import { store } from "./index";
import { setRedirectUrl } from "./redux/actions/loginRedirect";

const generalHandler: HandlerType = (error) => {
  // key is a constant because there should be at most one message error from api
  Message.error({ content: error.message, duration: 3, key: "api error" });
};

const statusHandlers: StatusHandlersTypes = {
  "401": async () => {
    const currentRoute = `${window.location.pathname}${window.location.search}`;
    await store.dispatch(setRedirectUrl(currentRoute));
    userManager.signinRedirect();
    Sentry.configureScope((scope) => scope.setUser(null));
  },
  "412": async () => {
    await store.dispatch(setShowTOTPModal(true));
  },
  default: generalHandler,
};

const domain = process.env.REACT_APP_DOMAIN || "";

const networkChecker = new Promise<void>((resolve) => {
  resolve();
});

apiConfigs.updateConfig({
  // set 30 second timeout for non-production environments due to low quality of servers
  ...(domain !== "payping.ir" ? { timeout: 30 * 1000 } : {}),
  domain,
  networkChecker,
  statusHandlers,
});
